import React from 'react'
import { Redirect } from 'react-router-dom'

import { logout } from '../../services/auth'

export default function Logout(props) {
  logout()
  return (
    <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
  )
}
